import { render, staticRenderFns } from "./TheSidebarOrder.vue?vue&type=template&id=36d7038e"
import script from "./TheSidebarOrder.vue?vue&type=script&lang=js"
export * from "./TheSidebarOrder.vue?vue&type=script&lang=js"
import style0 from "./TheSidebarOrder.vue?vue&type=style&index=0&id=36d7038e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports